<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><rect x="3" y="13" width="26" height="6" rx="2"/><rect x="3" y="3" width="26" height="6" rx="2"/><rect x="3" y="23" width="26" height="6" rx="2"/></svg>